import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMap } from 'react-map-gl'
import { disable3D, enable3D, is3DMode } from '../../../ducks/mapProperties'
import { UpsellTooltip } from 'components/Utilities/UpsellTooltip'


export default function CustomCompassControl() {
  const isPaidUser = window.data.has_sitecontrol
  const dispatch = useDispatch()
  const { current: map } = useMap()
  const is3D = useSelector(is3DMode)
  const tooltipText = '3D Terrain '
  const [showPitchAlert, setShowPitchAlert] = useState(false)
  const allowManualPitch = isPaidUser ? true : false
  const pitchAlertMessage = allowManualPitch
    ? 'Right click + drag to tilt/rotate the map'
    : '3D is available to Regrid Pro customers.'

  const startPitchAlert = () =>{
    setShowPitchAlert(true)
    setTimeout(() => setShowPitchAlert(false), 5000)
  }
  const handleClick = () => {
    if(!isPaidUser || !map) return
    //pitch the map before acually enabling 3D
    if(!is3D){
      startPitchAlert()
      const zoom = map.getZoom()
      const targetPitch = (zoom < 14) ? 60 : 45
      const targetZoom = (zoom > 17) ? 17 : zoom

      dispatch(enable3D())
      setTimeout(()=> {
        map.easeTo({pitch: targetPitch, zoom: targetZoom, duration: 500})
      }, 500)

    } else {
      dispatch(disable3D())
      setTimeout(()=> {
        map.easeTo({pitch: 0, bearing: 0, duration: 500})
      }, 500)
    }
  }

  map.getCanvas().addEventListener('mousedown', (e) => {
    if((e.ctrlKey || e.metaKey || e.button === 2) && !isPaidUser) {
      startPitchAlert()
    }
  })

  return (
    <div>
      <div className="modal-tile-wrapper maplibregl-control-container">
        <div id="map-compass-button" className="maplibregl-ctrl-bottom-right">
          <div className="maplibregl-ctrl maplibregl-ctrl-group">
            <button
              className={`${is3D ? 'plan-color-accent' : ''} ${is3D ? 'active' : ''}`}
              aria-label="Toggle 2D/3D Terrain"
              onClick={handleClick}
              data-for="3d-terrain-tt"
              data-tip={tooltipText}
              title="Toggle 2D/3D"
            >
              <span>{is3D ? '3D' : '2D'}</span>
              {!isPaidUser && (
                <UpsellTooltip id="3d-terrain-tt" featureMessage={tooltipText} />
              )}
            </button>
          </div>
        </div>
      </div>
      {showPitchAlert && (
        <div className="zoom-notifier-gl temporary">
          <span className="zoom-notifier-text centered">
            {pitchAlertMessage}
          </span>
        </div>
      )}
    </div>
  )
}